<script setup lang="ts">

import {LoadingState, showHideLoading, timeErrorMessage} from '@/base/loadingState.js';
import { AvailabilityState } from 'common';
import {onMounted, watch} from 'vue';
import {fetchAndSetState} from '@/base/TMP_globalState.js';

const props = defineProps<{
    state: LoadingState;
    stateForReporters: AvailabilityState
}>();

onMounted(async () => {
    onStateChange();
});

watch(() => props.state, () => {
    onStateChange();
});

function onStateChange() {
    showHideLoading(props.state === LoadingState.LOADING);
}

async function onRefresh() {
    await fetchAndSetState();
}

</script>

<template>
    <div v-if="state===LoadingState.TIME_ERROR" class="text-xl text-center w-full pt-20">
        Helaas, de tijd op je device wijkt teveel af van de server.
        <div class="flex flex-col items-center justify-center my-20">
            <div class="text-sm p-2 m-4 bg-amber-300 w-[400px] border border-gray-500 ">
                <div class="font-bold">
                    tech-info
                </div>
                <div class="p-2" v-html="timeErrorMessage"></div>
            </div>
        </div>
    </div>

    <div v-else-if="state===LoadingState.PERMISSION_ERROR" class="text-xl text-center w-full pt-20">
        Huh, je mist de nodige permissies...
    </div>

    <div v-else-if="state===LoadingState.GENERAL_ERROR" class="text-xl text-center w-full pt-20">
        Ach, er ging iets mis...
    </div>

    <div v-else-if="stateForReporters===AvailabilityState.closed" class="text-xl text-center w-full pt-20">
        Op dit moment is deze site gesloten.<br>
        Er kunnen geen rapportages worden ingezien of verwerkt.<br>
        Voor vragen kunt u contact opnemen met Popke Rein Munniksma van ZZC.
        <div class="mt-8">
            <button
                @click="onRefresh"
                class="bg-blue-500 hover:bg-blue-700 text-white text-base py-2 px-6 rounded cursor-pointer"
            >
                Opnieuw proberen
            </button>
        </div>
    </div>
</template>
